import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import Defs from '@bubble-ui/primitive-defs';
import LinearGradient from '@bubble-ui/primitive-linear-gradient';
import Stop from '@bubble-ui/primitive-stop';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var ColoredIllustrationFreeCashWithdrawal = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 100,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'ColoredIllustrationFreeCashWithdrawal',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 100 100",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint0_linear_21134_70177)",
    fillRule: "evenodd",
    d: "M10.54 48.77h70v-17c0-2.21-1.79-4-4-4h-56c-5.52 0-10 4.48-10 10v11Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FEB11F",
    fillRule: "evenodd",
    d: "M69.32 32.99c-1.82 4.65-8.43 6.42-14.77 3.94s-10.01-8.25-8.2-12.9l1.41-3.47s8.42-1.99 13.27-.09c4.97 1.94 9.7 9.06 9.7 9.06l-1.41 3.46Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#F4DC00",
    d: "M70.738 29.52c1.815-4.65-1.856-10.428-8.2-12.904-6.344-2.476-12.958-.713-14.773 3.938-1.816 4.651 1.855 10.429 8.2 12.905 6.343 2.476 12.958.713 14.773-3.939Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FF8043",
    fillRule: "evenodd",
    d: "M45.46 8.05c2.95 4.03.88 10.56-4.62 14.57s-12.34 4-15.29-.03l-2.17-3.06s2.85-8.17 7.06-11.24c4.31-3.14 12.86-3.3 12.86-3.3l2.16 3.06Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#FEB11F",
    d: "M38.672 19.563c5.5-4.018 7.57-10.542 4.624-14.574-2.945-4.031-9.79-4.043-15.29-.026-5.498 4.017-7.568 10.542-4.623 14.573 2.945 4.032 9.79 4.043 15.29.026Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "url(#paint1_linear_21134_70177)",
    fillRule: "evenodd",
    d: "M38.54 45.97H20.98c-5.76 0-10.44-2.43-10.44-8.19v49.56c0 5.76 4.67 10.44 10.44 10.44h66.49c2.21 0 4-1.79 4-4V49.97c0-2.21-1.79-4-4-4H38.54Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#9E58FF",
    fillRule: "evenodd",
    d: "M91.52 61.8v19.94H77.49s-6.85.01-6.85-9.97 6.85-9.97 6.85-9.97h14.03Z"
  }), /*#__PURE__*/React.createElement(Defs, null, /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint0_linear_21134_70177",
    x1: 15.945,
    x2: 87.531,
    y1: 64.203,
    y2: 7.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#A15CFD"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.515,
    stopColor: "#A460FB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#9E58FF"
  })), /*#__PURE__*/React.createElement(LinearGradient, {
    id: "paint1_linear_21134_70177",
    x1: -3.286,
    x2: 86.165,
    y1: 99.603,
    y2: 45.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement(Stop, {
    stopColor: "#00C9FF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.099,
    stopColor: "#11CBFA"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.293,
    stopColor: "#3CCFEF"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.565,
    stopColor: "#82D6DB"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 0.901,
    stopColor: "#E2DFC1"
  }), /*#__PURE__*/React.createElement(Stop, {
    offset: 1,
    stopColor: "#FFE2B9"
  }))));
};
ColoredIllustrationFreeCashWithdrawal.displayName = 'ColoredIllustrationFreeCashWithdrawal';
export default withProvisionalOverrideFromContext(ColoredIllustrationFreeCashWithdrawal);
//# sourceMappingURL=index.js.map